import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { contentGeneratorConfigVersionPopulatedSchema } from "../content-generator-config-version/content-generator-config-version-definition";

const contentGeneratorConfigSchema_ = z.object({
  _id: zExt.objectId(),
  teamId: zExt.objectId(),
  draftVersionId: zExt.objectId().optional(),
  publishedVersionId: zExt.objectId().optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

// Base schema
export const contentGeneratorConfigSchema = contentGeneratorConfigSchema_;
export type ContentGeneratorConfig = z.infer<
  typeof contentGeneratorConfigSchema
>;

// Populated version (contains expanded draft/published objects)
export const contentGeneratorConfigPopulatedSchema =
  contentGeneratorConfigSchema_
    .omit({ draftVersionId: true, publishedVersionId: true })
    .extend({
      draftVersion: contentGeneratorConfigVersionPopulatedSchema.optional(),
      publishedVersion: contentGeneratorConfigVersionPopulatedSchema
        .nullable()
        .optional(),
    });

export type ContentGeneratorConfigPopulated = z.infer<
  typeof contentGeneratorConfigPopulatedSchema
>;
